import { SnGridProps } from "./SnGrid_Types";
import { menuInfo } from "@shared/type/CommonType";
import { AgGridReact } from "ag-grid-react";
// SnGrid_options.ts
export function createGridOptionsExt(
  props: SnGridProps,
  gridRef: React.RefObject<AgGridReact>,
  menuInfo: menuInfo | undefined,
  menuItemsRef: React.MutableRefObject<{ name: string; action: () => void }[][]>
) {
  return {
    ...props.gridOptions,
    getRowId: (params: any) => params.data.KeyField,
    suppressAggFuncInHeader: true,
    suppressScrollOnNewData: true,
    suppressColumnVirtualisation: true,
    rowDragManaged: true,
    rowClassRules: {
      "group-row-style": (params: any) => params.node.group,
    },
    getContextMenuItems: (params: any) => {
      const today = new Date();
      const formattedDate = today.toISOString().slice(0, 10).replace(/-/g, "");
      const formattedTime = today.toTimeString().slice(0, 8).replace(/:/g, "");

      const defaultItems = Array.isArray(params.defaultItems)
        ? params.defaultItems
        : [];
      if (defaultItems.length === 0) {
        return [];
      }
      if (defaultItems.length > 6) {
        defaultItems[6] = {
          name: "내보내기",
          subMenu: [
            {
              name: "CSV로 내보내기",
              action: () =>
                gridRef.current!.api.exportDataAsExcel({
                  fileName: `${menuInfo?.nm_menu}[${formattedDate}${formattedTime}].csv`,
                  sheetName: "다운로드",
                }),
            },
            {
              name: "Excel로 내보내기",
              action: () =>
                gridRef.current!.api.exportDataAsExcel({
                  fileName: `${menuInfo?.nm_menu}[${formattedDate}${formattedTime}].xlsx`,
                  sheetName: "다운로드",
                }),
            },
          ],
        };
      }
      const customMenuItems = menuItemsRef.current.map((item: any) => {
        if (item.name === "-") {
          return "separator";
        }
        return {
          name: item.name,
          action: item.action,
        };
      });
      return [...defaultItems, "separator", ...customMenuItems];
    },
  };
}
